import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { baseApiService } from "../../../services/api/axios-config/axios-config";
import { SelectField } from "../../ui";

interface LaboBudgetConfig {
  id: string;
  description: string;
  unitOfMeasure: string;
  wage: number;
}

interface SelectLaboBudgetConfigProps {
  name: string;
  methods: any;
  disabled?: boolean;
  required?: boolean;
  label?: string;
  onChangeExtra?: (selected: LaboBudgetConfig | null) => void;
}

export function SelectLaboBudgetConfig({
  name,
  methods,
  disabled = false,
  required = false,
  label = "Selecione a Mão de Obra",
  onChangeExtra,
}: SelectLaboBudgetConfigProps) {
  const [configs, setConfigs] = useState<LaboBudgetConfig[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await baseApiService.get("company/select-labo-budget-config");
      setConfigs(data.data.data);
    };
    fetchData();
  }, []);

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <SelectField
          label={label}
          value={field.value || ""}
          onChange={(e) => {
            const selected = configs.find((c) => c.id === e.target.value);
            field.onChange(selected ? selected.id : ""); // salva só o id
            if (typeof onChangeExtra === 'function') {
              onChangeExtra(selected || null);
            }
          }}
          required={required}
          disabled={disabled}
        >
          <option value="" />
          {configs.map((config) => (
            <option key={config.id} value={config.id}>
              {`${config.description} - R$${config.wage}`}
            </option>
          ))}
        </SelectField>
      )}
    />
  );
}
